import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const username = localStorage.getItem('username');
    const userEmail = localStorage.getItem('userEmail');
    if (username) setUser({ username, email: userEmail });
    setLoading(false);
  }, []);

  const login = (username, email) => {
    localStorage.setItem('username', username);
    if (email) localStorage.setItem('userEmail', email);
    setUser({ username, email });
  };

  const logout = () => {
    localStorage.removeItem('username');
    localStorage.removeItem('userEmail');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
